import { AxiosResponse } from 'axios'
import { IDocumentoResponse } from 'modules/lotesSolicitados/domain/entities/IDocumentoResponse'
import { IDocumentosPdf } from 'modules/lotesSolicitados/domain/entities/IDocumentosPdf'
import ILoteSolicitadoRequest from 'modules/lotesSolicitados/domain/entities/ILoteSolicitadoRequest'
import { ServiceConfig } from 'shared/services/ServiceConfig'

import ILoteSolicitadoResponse from '../../domain/entities/LoteSolicitadoResponse'
import { ILoteSolicitadoRepository } from '../../domain/repositories/ILoteSolicitadoRepository'

const http = new ServiceConfig()
interface ILoteSolicitadoRequestParams {
  caminhao: string
  motorista: string
  cte: string
  order_by: string
  frotista_id: number
  cidadeOrigemIBGE?: number
  cidadeDestinoIBGE?: number
}
export default class LoteSolicitadoRepository
  implements ILoteSolicitadoRepository
{
  public async findAll({
    page,
    destino,
    motorista,
    cte,
    origem,
    placa,
    sort,
    frotistaId,
    cidadeDestinoIBGE,
    cidadeOrigemIBGE,
  }: ILoteSolicitadoRequest): Promise<ILoteSolicitadoResponse> {
    const filter = {} as ILoteSolicitadoRequestParams

    if (placa) {
      filter.caminhao = placa
    }

    if (motorista) {
      filter.motorista = motorista
    }

    if (cte) {
      filter.cte = cte
    }

    if (sort) {
      filter.order_by = sort
    }

    if (frotistaId) {
      filter.frotista_id = frotistaId
    }

    if (cidadeOrigemIBGE) {
      filter.cidadeOrigemIBGE = cidadeOrigemIBGE
    }

    if (cidadeDestinoIBGE) {
      filter.cidadeDestinoIBGE = cidadeDestinoIBGE
    }

    const response: AxiosResponse<ILoteSolicitadoResponse> = await http.get(
      '/lotes-solicitados',
      {
        params: {
          page,
          per_page: 15,
          origem,
          destino,
          ...filter,
        },
      },
    )

    return response.data
  }

  public async endTrip(loteConjuntoId: number): Promise<void> {
    await http.patch(`/finalizar/viagem?lote_conjunto_id=${loteConjuntoId}`)
  }

  public async cancelTrip(loteConjuntoId: number): Promise<void> {
    await http.patch(`/cancelar/viagem?lote_conjunto_id=${loteConjuntoId}`)
  }

  public async sendSms(loteId: number, sendSms: boolean): Promise<void> {
    await http.patch(`/lotes-solicitados/${loteId}`, {
      send_sms: sendSms,
    })
  }

  public async getDocumentos(
    tmovLoteConjuntoId: number,
  ): Promise<IDocumentoResponse[]> {
    const response: AxiosResponse<IDocumentoResponse[]> = await http.get(
      `/lotes-solicitados/documentos/${tmovLoteConjuntoId}`,
    )

    return response.data
  }

  public async getAllDocumentosPdf(
    tmovLoteConjuntoId: number,
  ): Promise<IDocumentosPdf> {
    const response: AxiosResponse<IDocumentosPdf> = await http.get(
      `/lotes-solicitados/documentos-agrupados/${tmovLoteConjuntoId}`,
    )

    return response.data
  }

  public async getDocumentoPdf(params: string): Promise<IDocumentosPdf> {
    const response: AxiosResponse<IDocumentosPdf> = await http.get(
      `/lotes-solicitados/documento?${params}`,
    )

    return response.data
  }

  public async getDocumentoPedagioPdf(params: string): Promise<IDocumentosPdf> {
    const response: AxiosResponse<IDocumentosPdf> = await http.get(
      `/lotes-solicitados/documento-pedagio?${params}`,
    )

    return response.data
  }
}
